import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Spinner, Alert, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const VerifyEmail: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setSuccess(false);
        setMessage('Invalid verification link.');
        setLoading(false);
        return;
      }

      try {
        const apiBaseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
        const response = await axios.get(`${apiBaseUrl}/auth/verify-email/${token}`);

        setSuccess(response.data.success);
        setMessage(response.data.message || 'Email verified successfully.');
      } catch (error: any) {
        setSuccess(false);
        setMessage(error.response?.data?.message || 'Verification failed. Please request a new verification email.');
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [token]);

  return (
    <div
      className="min-vh-100 d-flex align-items-center public-page"
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        position: 'relative'
      }}
    >
      <Container className="position-relative">
        <Row className="justify-content-center">
          <Col lg={5} md={7} sm={9}>
            <Card className="border-0 shadow-lg">
              <Card.Body className="p-5 text-center">
                <h2 className="fw-bold text-dark mb-3">Email Verification</h2>

                {loading ? (
                  <div className="py-3">
                    <Spinner animation="border" role="status" className="mb-3" />
                    <p className="text-muted mb-0">Verifying your email...</p>
                  </div>
                ) : (
                  <>
                    <Alert
                      variant={success ? 'success' : 'danger'}
                      className={`border-0 ${success ? 'bg-success bg-opacity-10 text-success' : 'bg-danger bg-opacity-10 text-danger'}`}
                    >
                      <i className={`fas ${success ? 'fa-check-circle' : 'fa-exclamation-circle'} me-2`}></i>
                      {message}
                    </Alert>

                    <div className="d-grid gap-2 mt-4">
                      <Button
                        onClick={() => navigate('/login')}
                        className="btn-lg border-0 fw-semibold py-3"
                        style={{
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          fontSize: '1rem'
                        }}
                      >
                        <i className="fas fa-sign-in-alt me-2"></i>
                        Go to Login
                      </Button>
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VerifyEmail;
